
// Menu size: md and below
const classList = [
    'mobile-nav__item--level-0__active__invisible',
    'mobile-nav__item--level-0__active',
    'mobile-nav__item--level-1__active',
    'mobile-nav__item--level-0__invisible',
    'mobile-nav__item--level-1__invisible',
    'mobile-nav__sub--level-1__visible',
    'mobile-nav__sub--level-2__visible',
    'mobile-nav__sub--level-1__visible__expanded',
];

// Menu size: lg
const itemCollection = document.getElementsByClassName('main-nav__item--level-0');
const flyout = document.getElementsByClassName('nav__flyout').item(0);
const overlay = document.getElementsByClassName('nav__overlay').item(0);
const closeMd = document.getElementsByClassName('nav__meta__md__menu__control').item(0);
const closeDesktop = document.querySelector('.nav__flyout-level-2__close');
const mobileNav = document.getElementsByClassName('nav__mobile').item(0);

// Resets mobile menu to its initial state
const resetMobileMenu = () => {
    Array.from(document.querySelectorAll('.mobile-nav__item')).forEach((item) => item.classList.remove(...classList));
    Array.from(document.querySelectorAll('.mobile-nav__sub')).forEach((item) => item.classList.remove(...classList));
};

// Close Menu
const resetDesktopMenu = () => {
    flyout.classList.remove('nav__flyout__visible');
    overlay.classList.remove('nav__overlay__visible');
    document.body.style.overflow = 'auto';
    if (mobileNav.classList.contains('nav__mobile__visible')) {
        mobileNav.classList.remove('nav__mobile__visible');
        closeMd.classList.remove('nav__meta__md__menu__control__active');
        resetMobileMenu();
    }
};

overlay.addEventListener('mouseenter', () => {
    resetDesktopMenu();
});
closeDesktop.addEventListener('click', () => {
    resetDesktopMenu();
});

const menuHasChild = el => el.classList.contains('main-nav__item--parent');

// Show Flyout
Array.from(itemCollection).forEach(item => {
    item.addEventListener('mouseenter', () => {
        if (menuHasChild(item)) {
            flyout.classList.add('nav__flyout__visible');
            overlay.classList.add('nav__overlay__visible');
            document.body.style.overflow = 'hidden';
        } else {
            resetDesktopMenu();
        }
    });
});

const subNavCollectionLevelOne = document.getElementsByClassName('main-nav__sub--level-1');
const flyoutLevelTwo = document.getElementsByClassName('nav__flyout--level-2').item(0);


// is this even useful ?
Array.from(subNavCollectionLevelOne).forEach(item => {
    if (menuHasChild(item)) {
        item.addEventListener('mouseenter', () => {
            flyoutLevelTwo.classList.add('nav__flyout--level-2__visible');
        });
    } else {
        item.addEventListener('mouseout', () => {
            flyoutLevelTwo.classList.remove('nav__flyout--level-2__visible');
        });
    }
});

// Show Flyout Level 2
const subNavItemCollectionLevelOne = document.getElementsByClassName('main-nav__item--level-1');
Array.from(subNavItemCollectionLevelOne).forEach(item => {
    item.addEventListener('mouseenter', () => {
        if (menuHasChild(item)) {
            flyoutLevelTwo.classList.add('nav__flyout--level-2__visible');
            const navWidth = document.querySelector('.nav__main').offsetWidth + 'px';
            item.querySelector('.main-nav__list').style.left = navWidth;
        } else {
            flyoutLevelTwo.classList.remove('nav__flyout--level-2__visible');
        }
    });
});


// Toggle Flyout Level 2 if no level 3 is present
Array.from(subNavItemCollectionLevelOne).forEach(item => {
    item.addEventListener('mouseover', () => {
        if (menuHasChild(item)) {
            flyoutLevelTwo.classList.add('nav__flyout--level-2__visible');
        } else {
            flyoutLevelTwo.classList.remove('nav__flyout--level-2__visible');
        }
    });
});


// Toggle menu
closeMd.addEventListener('click', () => {
    if (flyout.classList.contains('nav__flyout__visible')) {
        flyout.classList.remove('nav__flyout__visible');
        overlay.classList.remove('nav__overlay__visible');
        mobileNav.classList.remove('nav__mobile__visible');
        closeMd.classList.remove('nav__meta__md__menu__control__active');
        document.body.style.overflow = 'auto';
        resetMobileMenu();
    } else {
        flyout.classList.add('nav__flyout__visible');
        overlay.classList.add('nav__overlay__visible');
        mobileNav.classList.add('nav__mobile__visible');
        closeMd.classList.add('nav__meta__md__menu__control__active');
        document.body.style.overflow = 'hidden';
    }
});

const mobileItemCollection = document.getElementsByClassName('mobile-nav__item--level-0');
const siblings = x => [...x.parentElement.children].filter(c => c !== x);

// Toggle menu level 1
Array.from(mobileItemCollection).forEach(item => {
    item.addEventListener('click', () => {
        const mobileSubNavLevelOne = item.getElementsByClassName('mobile-nav__sub--level-1').item(0);
        if (item.classList.contains('mobile-nav__item--level-0__active')) {
            item.classList.remove('mobile-nav__item--level-0__active');
            mobileSubNavLevelOne.classList.remove('mobile-nav__sub--level-1__visible');

            siblings(item).forEach(sibling => {
                sibling.classList.remove('mobile-nav__item--level-0__invisible');
            });
            return;
        }
        item.classList.add('mobile-nav__item--level-0__active');
        siblings(item).forEach(sibling => {
            sibling.classList.add('mobile-nav__item--level-0__invisible');
        });
        mobileSubNavLevelOne.classList.add('mobile-nav__sub--level-1__visible');
    });
});

const mobileItemCollectionLevelOne = document.getElementsByClassName('mobile-nav__item--level-1');

// Toggle menu level 2
Array.from(mobileItemCollectionLevelOne).forEach(item => {
    item.addEventListener('click', (event) => {
        event.stopPropagation();

        const parentItem = document.getElementsByClassName('mobile-nav__item--level-0__active').item(0);
        const mobileSubNavLevelOne = parentItem.getElementsByClassName('mobile-nav__sub--level-1__visible').item(0);
        const mobileSubNavLevelTwo = item.getElementsByClassName('mobile-nav__sub--level-2').item(0);

        if (item.classList.contains('mobile-nav__item--level-1__active')) {
            parentItem.classList.remove('mobile-nav__item--level-0__active__invisible');
            item.classList.remove('mobile-nav__item--level-1__active');
            mobileSubNavLevelTwo.classList.remove('mobile-nav__sub--level-2__visible');
            mobileSubNavLevelOne.classList.remove('mobile-nav__sub--level-1__visible__expanded');

            siblings(item).forEach(sibling => {
                sibling.classList.remove('mobile-nav__item--level-1__invisible');
            });

            return;
        }

        parentItem.classList.add('mobile-nav__item--level-0__active__invisible');
        mobileSubNavLevelOne.classList.add('mobile-nav__sub--level-1__visible__expanded');

        item.classList.add('mobile-nav__item--level-1__active');

        siblings(item).forEach(sibling => {
            sibling.classList.add('mobile-nav__item--level-1__invisible');
        });

        mobileSubNavLevelTwo.classList.add('mobile-nav__sub--level-2__visible');
    });
});



// WEBPACK FOOTER //
// ./src/scripts/components/nav/index.js